var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58549 6.73595L10.184 1.50394C10.2596 1.35253 10.3759 1.22517 10.5199 1.13616C10.6639 1.04715 10.8298 1 10.9991 1C11.1684 1 11.3343 1.04715 11.4783 1.13616C11.6223 1.22517 11.7386 1.35253 11.8142 1.50394L14.4127 6.73595L20.2218 7.57995C20.3893 7.60318 20.547 7.67304 20.6767 7.78156C20.8064 7.89008 20.9031 8.03289 20.9555 8.19368C21.008 8.35447 21.0142 8.52677 20.9734 8.69091C20.9326 8.85504 20.8465 9.00441 20.7248 9.12195L16.5221 13.192L17.5143 18.942C17.6413 19.68 16.8611 20.242 16.194 19.894L10.9991 17.178L5.80317 19.894C5.13705 20.243 4.35691 19.68 4.48393 18.941L5.47611 13.191L1.27336 9.12095C1.15232 9.00333 1.06672 8.85411 1.02628 8.69027C0.985836 8.52642 0.992179 8.35452 1.04459 8.1941C1.09699 8.03368 1.19336 7.89117 1.32273 7.78278C1.45211 7.67439 1.6093 7.60447 1.77645 7.58095L7.58549 6.73595Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 15,
    r: 5.5,
    fill: "#333333",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 14.25H17.75V12.75C17.75 12.5511 17.671 12.3603 17.5303 12.2197C17.3897 12.079 17.1989 12 17 12C16.8011 12 16.6103 12.079 16.4697 12.2197C16.329 12.3603 16.25 12.5511 16.25 12.75L16.2766 14.25H14.75C14.5511 14.25 14.3603 14.329 14.2197 14.4697C14.079 14.6103 14 14.8011 14 15C14 15.1989 14.079 15.3897 14.2197 15.5303C14.3603 15.671 14.5511 15.75 14.75 15.75L16.2766 15.7234L16.25 17.25C16.25 17.4489 16.329 17.6397 16.4697 17.7803C16.6103 17.921 16.8011 18 17 18C17.1989 18 17.3897 17.921 17.5303 17.7803C17.671 17.6397 17.75 17.4489 17.75 17.25V15.7234L19.25 15.75C19.4489 15.75 19.6397 15.671 19.7803 15.5303C19.921 15.3897 20 15.1989 20 15C20 14.8011 19.921 14.6103 19.7803 14.4697C19.6397 14.329 19.4489 14.25 19.25 14.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkAll);
export default __webpack_public_path__ + "static/media/BookmarkAll.a2847dd64a38e6d2b66fabcbbe8af174.svg";
export { ForwardRef as ReactComponent };